// Override default nuxt scroll behavior (adds smooth scrolling)

export default async (to, from, savedPosition) => {
  if (savedPosition) {
    return savedPosition;
  }

  const findEl = async (hash, x) => (
    document.querySelector(hash)
      || new Promise((res) => {
        if (x > 50) {
          return res();
        }

        const inc = x + 1;

        return setTimeout(() => { res(findEl(hash, inc || 1)); }, 100);
      })
  );

  // an: PDP scroll page is handle manually (see PDPDSectionTabs.vue)
  // jw: since legacy PDP uses django this products page is guaranteed to be the new version.
  if (to.hash && !to.path.includes('/products/')) {
    const el = await findEl(to.hash);

    if (el) {
      const newPosition = el.getBoundingClientRect()?.top + window.pageYOffset;

      if ('scrollBehavior' in document.documentElement.style) {
        return window.scrollTo({ top: newPosition, behavior: 'smooth' });
      }

      return window.scrollTo(0, newPosition);
    }
  }

  return { x: 0, y: 0 };
};
